;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "3XOgdsC7IP"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  var $this = jQuery(this);
  function splitChar(){
    var element = $this.find('.lh-subtitle p');
    var text = section.settings.subtitle;
    element.html('');
    for (var i = 0; i < text.length; i++) {
        var html = '<span style="transition-delay: '+(i *40)+'ms;'+(text.charAt(i) == ' ' ? 'display: inline':'')+'">' + text.charAt(i) + "</span>";
        element.append(html);;
    }
    setTimeout(function(){
      element.addClass('lh-show').find('span').addClass('lh-show');
    },1500);
  }
  splitChar();
 };						cb.bind($('section[data-section-id="3XOgdsC7IP"] include[data-name="subtitle"][data-id="1"]').get(0))(jQuery);;var cb  = function($) {
  var $this = jQuery(this);
  var count = 0;
  function animateImg(event) {
      count++;
      if(count % 15 != 0) return;
      var w_top   = $(window).scrollTop(),
      __this      = $(event.currentTarget) ,
      _this_w     = __this.width(),
      _ratio      = _this_w / 60,
      _offset_l   = __this.offset().left,
      _m_x        = event.originalEvent.pageX,
      _x_new      = (_offset_l + _this_w / 2 - _m_x) / _ratio;
      __this.find('.lh-block-main').css({'left': _x_new});
  }
  function setOrigin(event){
    var __this  = $(event.currentTarget),
    img         = __this.find('.lh-block-main');
    img.removeAttr('style');
  }
  setTimeout(function(){
    $this.find('.lh-block-main').addClass('lh-show');
  },1000);
  $(window).resize(function(){
    var w_w = $(window).width();
    var item = $this;
    if(w_w >= 1200){
      if(!item.hasClass('lh-added-event')){
        item.addClass('lh-added-event');
        item.mousemove(animateImg);
        item.mouseleave(setOrigin);
      }
    }else{
      item.unbind();
      item.removeClass('lh-added-event');
    }
  }).trigger('resize');
 };						cb.bind($('section[data-section-id="3XOgdsC7IP"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="3XOgdsC7IP"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWF5LS0yMDIw/NTkwNDU2ODky/twenty-twenty-summer/pages/gx9CeGoZjAM2isuB/static-banner/",						settings: {"subtitle":"ABOUT US"}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "odMRgbknEq"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="odMRgbknEq"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWF5LS0yMDIw/NTkwNDU2ODky/twenty-twenty-summer/pages/gx9CeGoZjAM2isuB/services/",						settings: {}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "r2PCxg19lZ"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  var _this = jQuery(this),
      _dom  = _this.find('.lh-counter-section'),
      counter = _this.find('.lh-counter-number');
  function numberWithCommas(num , separator) {
    if(!separator) return num;
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }
  let regexExt    = /([^\d]+)$/g;
  let regexFText  = /^([^\d]+)/g;
  function getTextInNumber(num, regex){
    f = regex.exec(num.toString());
    return f ? f[0] : ''
  }
  function getSeparatorNumber(num){
    num = num.toString().replace(regexExt,'').replace(regexFText,'');
    separator = /([^\d]+)/g.exec(num.toString());
    return separator ? separator[0] : '';
  }
  function getNum(num){
    num = num.toString().replace(/([^\d])/g,'');
    num = parseInt(num);
    return num ? num : 0;
  }
  function startCounter(){
    _dom.addClass('lh-init');
    counter.each(function() {
    var $this     = $(this),
        num       = $this.attr('data-number'),
        countTo   = getNum(num),
        ext       = getTextInNumber(num, regexExt),
        fText     = getTextInNumber(num, regexFText),
        separator = getSeparatorNumber(num);
    if(countTo < 1) return;
    $({ countNum: 0}).animate({
      countNum: countTo
      },
      {
        duration: parseFloat(section.settings.duration) * 1000,
        easing:'linear',
        step: function() {
          $this.text(fText + numberWithCommas(Math.floor(this.countNum), separator));
        },
        complete: function() {
          $this.text(fText + numberWithCommas(Math.floor(this.countNum), separator) + ext);
        }

      });
    });
  }
  function isAnyPartOfElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);
    const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
    const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

    return (vertInView && horInView);
  }
  var time ;
  $(window).on('scroll resize',function(){
    if(time) clearTimeout(time);
    time = setTimeout(function(){
      if(!_dom.hasClass('lh-init')){
         isAnyPartOfElementInViewport(counter[0]) && startCounter();
      }
    },150);

  }).trigger('scroll');
 };						cb.bind($('section[data-section-id="r2PCxg19lZ"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="r2PCxg19lZ"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWF5LS0yMDIw/NTkwNDU2ODky/twenty-twenty-summer/pages/gx9CeGoZjAM2isuB/counter/",						settings: {"duration":1}					}, jQuery);})(jQuery);;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "rGZ1avDndO"							}), success: c, error: e});						}, cb  = function(section, $) {};					cb.bind($('section[data-section-id="rGZ1avDndO"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWF5LS0yMDIw/NTkwNDU2ODky/twenty-twenty-summer/pages/gx9CeGoZjAM2isuB/member-grid/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');window.addEventListener("load",()=>{let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 15px","width: 100%","text-align: center","opacity: 1","z-index: 10000000000000000","text-indent: 0","color: #333","background: #fff",""].join(" !important;")),b.innerHTML="Page layout provided by &hearts; <a href=\"https://www.layouthub.com/?utm_source=client-site&utm_medium=footer&utm_campaign=freemium&utm_term=links&utm_content="+window.location.origin+"\">Layouthub.com</a>",a.appendChild(b)});